export default function(phone) {
  if (phone) {
    phone = typeof phone != "string" ? phone.toString() : phone;

    if (phone.length == 10) {
      phone = phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else {
      phone = phone.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4");
    }
  }

  return phone;
}
